import React, { useEffect } from "react";
import styled from "styled-components";
import TitleSeparator from "../../../components/title-separator/TitleSeparator";
import { strings, withLocalizeStrings } from "../../../languages/Localize";
import { Box, Flex } from "reflexbox/src";
import { Formik } from "formik";
import { loginValidator } from "../../register.validator";
import LoginForm from "./LoginForm";
import { Button } from "antd";
import { useRegisterStateValue } from "../../RegisterContext";

const StyledAccreditations = styled(Flex)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
`;

const StyledLoginContainer = styled(Flex)`
    width: 92%;
    flex: 1;
    text-align: center;
    flex-direction: column;
    && {
        margin: 12px 4% 0% 4%;
    }
`;

const StyledRegisterContainer = styled(Flex)`
    width: 92%;
    flex: 1;
    text-align: center;
    flex-direction: column;
    border-top: 1px solid #fff;
    box-sizing: border-box;
    padding-top: 22px;
    padding-bottom: 22px;
    && {
        margin: 12px 4% 0% 4%;
    }
`;

const LoginDescription = styled.span`
    color: #fff;
`;

const RegisterDescription = styled.span`
    color: #fff;
    margin-bottom: 22px;
`;

const StyledButtonContainer = styled(Box)`
    text-align: center;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.primary};
    width: 60%;
    min-width: 180px;
    height: 50px;
    border: none;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    font-size: 24px;
    &:focus,
    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
    &:active {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const ErrorMessage = styled.div`
    color: red;
    height: 24px;
    font-weight: 700;
`;

const AccreditationHome = props => {
    const setLoginFormField = field => {
        let code;
        if (field.code) code = field.code.split(" ").join("");
        setLoginForm(prevState => ({ ...prevState, ...field, code: code }));
    };
    const { errorMessage, nextScreen, setLoginForm, loginForm, isLoginFormValid, setLoginFormValid } = useRegisterStateValue();

    return (
        <StyledAccreditations>
            <TitleSeparator>{strings.register.accreditationHome.HEADER}</TitleSeparator>
            <StyledLoginContainer>
                <LoginDescription>{strings.register.accreditationHome.loginDescription}</LoginDescription>
                <Formik
                    validationSchema={loginValidator(strings)}
                    initialValues={loginForm}
                    isValid={isLoginFormValid}
                    isInitialValid={isLoginFormValid}>
                    {innerPops => (
                        <LoginForm
                            onValidityChange={setLoginFormValid}
                            isFormValid={isLoginFormValid}
                            onFormChange={setLoginFormField}
                            {...innerPops}
                        />
                    )}
                </Formik>
                <ErrorMessage>{errorMessage}</ErrorMessage>
                <StyledButtonContainer sx={{ m: [0, 4], px: [1, 2], fontSize: [2, 3] }}>
                    <StyledButton disabled={!isLoginFormValid} onClick={() => nextScreen(true)}>
                        {strings.register.accreditationHome.LOGIN_BUTTON}
                    </StyledButton>
                </StyledButtonContainer>
            </StyledLoginContainer>
            {/*<StyledRegisterContainer>*/}
            {/*    <RegisterDescription>{strings.register.accreditationHome.registerDescription}</RegisterDescription>*/}
            {/*    <StyledButtonContainer sx={{ m: [0, 4], px: [1, 2], fontSize: [2, 3] }}>*/}
            {/*        <StyledButton onClick={() => nextScreen(false)}>{strings.register.accreditationHome.REGISTER_BUTTON}</StyledButton>*/}
            {/*    </StyledButtonContainer>*/}
            {/*</StyledRegisterContainer>*/}
        </StyledAccreditations>
    );
};

export default withLocalizeStrings(AccreditationHome);
